import toast from 'react-hot-toast'
import { useAppDispatch } from '../../reducers/store'
import { fetchMembers, postUnblockMember, selectMembers } from '../../reducers/members'
import { IconHourglassHigh } from '@tabler/icons-react'
import { useState } from 'react'
import { SelectOption } from '../../types/DropDownTypes'
import { gracePeriodOptions } from '../../strings/dropdown-options'
import { GracePeriod } from '../../types/MemberTypes'
import { useSelector } from 'react-redux'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

interface IUnblockMemberModalProps {
  setShowModal: (show: boolean) => void
  memberName: string
  memberId: string
  memberBlockedByPolicy: string
  setShowPopout: (show: boolean) => void
}

function UnblockMemberModal(props: IUnblockMemberModalProps) {
  const { setShowModal, memberName, memberId, memberBlockedByPolicy, setShowPopout } = props
  const di = useAppDispatch()
  const [gracePeriod, setGracePeriod] = useState<string>(GracePeriod.ONE_HOUR)
  const { filters } = useSelector(selectMembers)

  const handleUnblockMember = async () => {
    const memberUnblocked = await di(postUnblockMember(memberId, memberBlockedByPolicy, gracePeriod))
    if (!memberUnblocked) {
      toast.error('An error occurred while resuming member access', DEFAULT_TOAST_CONFIG)
    } else {
      toast.success(`Access for ${memberName} will be reinstated. This may take a few minutes`, DEFAULT_TOAST_CONFIG)
    }
    di(fetchMembers(filters))
    setShowPopout(false)
    setShowModal(false)
  }

  return (
    <div className="bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-50" onClick={() => setShowModal(false)}>
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[80%] w-[388px] overflow-y-auto border dark:border-gray-600"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="block">
          <p className="text-2xl font-semibold">Remove Suspension</p>
        </div>
        <p className="mb-4 text-sm text-ErrorRed">
          Please note: if the member has any open alerts these will be closed when member access is resumed.
        </p>
        <div className="flex justify-between mt-10">
          <div className="flex mt-1.5">
            <IconHourglassHigh size={20} className="mt-0.5" />
            <p className="leading-normal ml-2">Expires after</p>
          </div>
          <select
            className="h-10 w-[180px] bg-inputBackground flex border rounded px-2 py-2.5 justify-between text-sm focus:border-borderPurple focus:border-2 hover:border hover:border-borderPurple hover:dark:border-borderPurple not-form-styled"
            value={gracePeriod}
            onChange={(e) => setGracePeriod(e.target.value)}
          >
            {gracePeriodOptions.map((option: SelectOption) => {
              return (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              )
            })}
          </select>
        </div>

        <div className="flex justify-end mt-8">
          <button
            className="px-4 py-2 mr-2 bg-gray-300 rounded-lg text-neutral-12"
            onClick={() => {
              setShowModal(false)
            }}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 bg-mainPurple text-white rounded-lg ${gracePeriod === '' ? 'cursor-not-allowed opacity-50' : ''}`}
            onClick={() => {
              handleUnblockMember()
            }}
            disabled={gracePeriod === ''}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  )
}

export default UnblockMemberModal
